import { defineMessages } from 'react-intl';

export default defineMessages({
    buildingID: {
        id: "twia.quoteandbind.cp.views.building.Building ID",
        defaultMessage: "Building ID"
    },
   buildingNumber: {
        id: "twia.quoteandbind.cp.views.building.Building Number",
        defaultMessage: "Building Number"
    },
    unitNumber: {
        id: "twia.quoteandbind.cp.views.building.Unit Number",
        defaultMessage: "Unit Number"
    },
    description: {
        id: "twia.quoteandbind.cp.views.building.Building Description",
        defaultMessage: "Building Description"
    },
    coverageForm: {
        id: "twia.quoteandbind.cp.views.building.Coverage Form",
        defaultMessage: "Coverage Form"
    },
    pleaseSelect: {
        id: "twia.quoteandbind.cp.views.building.Please Select",
        defaultMessage: "Please Select"
    },
    classCode: {
        id: "twia.quoteandbind.cp.views.building.Property Class Code",
        defaultMessage: "Property Class Code"
    },
    classCodeDescription: {
        id: "twia.quoteandbind.cp.views.building.Property Class Description",
        defaultMessage: "Property Class Description"
    },
    riskType: {
        id: "twia.quoteandbind.cp.views.building.Risk Item Type",
        defaultMessage: "Risk Item Type"
    },
    buildersRiskForm: {
        id: "twia.quoteandbind.cp.views.building.Builder's Risk Form",
        defaultMessage: "Builder's Risk Form"
    },
    required: {
        id: 'twia.quoteandbind.cp.views.building.This is a required field.',
        defaultMessage: 'This is a required field.'
    }
})